import React from "react";
import { ASSETS } from "../../config/assets";

const FeaturePage = ({ title, description }) => (
  <div className="biz-panel-page biz-feature-page">
    <div className="biz-panel-header">
      <h1>{title}</h1>
    </div>
    {description && <p className="biz-page-desc">{description}</p>}
    <div className="biz-feature-placeholder">
      <p>
        This section mirrors the{" "}
        <a
          href={ASSETS.brandDomain}
          target="_blank"
          rel="noopener noreferrer"
        >
          {ASSETS.brandName} business dashboard
        </a>
        . Connect your API backend to enable full functionality.
      </p>
    </div>
  </div>
);

export default FeaturePage;
